import { useState, useEffect } from 'react';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <img
        src="https://public.readdy.ai/ai/img_res/e4e4ff77eb1813d81a92bf8a73eb1d71.jpg"
        alt="Fixcope 글로벌 솔루션 배경"
        className={`absolute inset-0 w-full h-full object-cover object-top transition-transform duration-[2500ms] ease-out ${loaded ? 'scale-100' : 'scale-110'}`}
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-5xl mx-auto px-6 w-full">
        {/* Badge */}
        <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/25 backdrop-blur-sm mb-8 transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <span className="w-2 h-2 rounded-full bg-[#FF8C3A] inline-block"></span>
          <span className="text-white/90 text-sm font-medium whitespace-nowrap tracking-wide">Global Tech Solution Partner</span>
        </div>

        {/* Main Headline */}
        <h1 className={`text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight tracking-tight transition-all duration-700 delay-200 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="block">기술과 신뢰로 연결하는</span>
          <span className="block text-[#FF8C3A] whitespace-nowrap">글로벌 솔루션 파트너</span>
        </h1>

        {/* Sub Copy */}
        <p className={`text-sm sm:text-base md:text-lg text-white/80 mb-10 sm:mb-12 max-w-3xl mx-auto leading-relaxed transition-all duration-700 delay-[400ms] ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          픽스코프는 기술력과 글로벌 네트워크를 바탕으로 첨단 제품 및 서비스를 개발하고 제공합니다.
          <br className="hidden sm:block" />
          머신비전, 초소형 산업용카메라의 개발을 비롯하여 국산 의료장비 및 제품의 글로벌 공급과
          <br className="hidden sm:block" />
          기업 해외진출 프로젝트 컨설팅을 통해 산업과 의료 혁신을 이끄는 기술 솔루션 기업입니다.
        </p>

        {/* CTA Buttons */}
        <div className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 delay-[600ms] ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <button
            onClick={() => handleScroll('#business')}
            className="px-8 py-4 bg-[#E8650A] text-white rounded-lg font-semibold text-sm hover:bg-[#C95508] hover:scale-105 active:scale-95 transition-all whitespace-nowrap cursor-pointer"
          >
            사업 분야 알아보기
          </button>
          <button
            onClick={() => handleScroll('#contact')}
            className="px-8 py-4 border-2 border-white/60 text-white rounded-lg font-semibold text-sm hover:bg-white/10 hover:border-white hover:scale-105 active:scale-95 transition-all whitespace-nowrap cursor-pointer"
          >
            문의하기
          </button>
        </div>


      </div>

      {/* Scroll Indicator */}
      <div className={`absolute bottom-10 left-1/2 -translate-x-1/2 transition-all duration-700 delay-[1000ms] ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-1.5">
          <div className="w-1.5 h-1.5 rounded-full bg-white/70 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
